import type { ServerColDef } from '@cmg/data-grid';
import { createValueFormatter } from '@cmg/data-grid';

import type { FirmSalesCoverageGridItemFragment } from '../graphql/__generated__';

const valueFormatter = createValueFormatter<
  FirmSalesCoverageGridItemFragment,
  FirmSalesCoverageGridItemFragment['employeeKey']
>();

export const employeeKeyColDef: ServerColDef<FirmSalesCoverageGridItemFragment> = {
  field: 'employeeKey',
  headerName: 'Employee Key',
  valueFormatter,
};
